import { Artist } from "@/types/defs/artist";

export const getArtistSweetSpot = (artist: Artist): number | null => {
  const { sweetSpot } = artist.filters.pitchRange;
  if (sweetSpot === undefined) {
    return null;
  }
  return sweetSpot;
};
